import React from "react";
import { Link } from "react-router-dom";
import Dropdown from "../../Component/MDBShim/Dropdown";
import DropdownMenu from "../../Component/MDBShim/DropdownMenu";
import DropdownToggle from "../../Component/MDBShim/DropdownToggle";
import Fa from "../../Component/MDBShim/Fa";
import MDBNav from "../../Component/MDBShim/MDBNav";
import MDBNavItem from "../../Component/MDBShim/MDBNavItem";
import MDBNavLink from "../../Component/MDBShim/MDBNavLink";
import MUIBreadcrumbs from "@mui/material/Breadcrumbs";
import "./pageHeader.css";
import MainContext from "../../Context/MainContext/MainContext";
export default class PageHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            actionItems: props.actionItems,
        };
    }

    static contextType = MainContext;

    componentDidUpdate(prevProps) {
        if (prevProps.actionItems !== this.props.actionItems) {
            this.setState({ actionItems: this.props.actionItems });
        }
    }

    renderNavTab() {
        const { breadCrumbs, tabNames, TabsOneActiveItem, toggle } = this.props;

        return (
            <div>
                <MDBNav tabs className="nav-justified navGrey">
                    <MUIBreadcrumbs
                        aria-label="breadcrumb"
                        style={{ minWidth: "20vw", fontSize: "16px", padding: "0 .5rem" }}
                    >
                        {breadCrumbs?.map((bread, idx) =>
                            idx < breadCrumbs.length - 1 ? (
                                <Link
                                    key={idx}
                                    to={bread.path}
                                    style={{ color: "#292929", padding: "0px", textDecoration: "none" }}
                                >
                                    {bread.title}
                                </Link>
                            ) : (
                                <div key={idx} style={{ color: "#5881c1" }}>
                                        {bread.title}
                                    </div>
                                )
                            )}
                        </MUIBreadcrumbs>

                    {tabNames?.map((tab, idx) => {
                        const tabId = (idx + 1).toString();
                        return (
                            <MDBNavItem key={tabId}>
                                <MDBNavLink
                                    link
                                    to="#"
                                    role="tab"
                                    active={TabsOneActiveItem === tabId}
                                    style={{
                                        textTransform: "uppercase",
                                        color: "#a1a1a1",
                                        fontWeight: "400",
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%", // ensure vertical centering
                                    }}
                                    className={
                                        TabsOneActiveItem === tabId ? "highlight" : "nonHighlight"
                                    }
                                    onClick={() => toggle("1", tabId)}
                                >
                                    {tab}
                                </MDBNavLink>
                            </MDBNavItem>
                        );
                    })}
               

                    <MDBNavItem className="actionMenuDropdown1">
                        <Dropdown className="actionMenuDropdown1">
                            <DropdownToggle className="actionMenuDropdown" nav>
                                <span
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        backgroundColor: "#fff",
                                        whiteSpace: "nowrap",
                                        border: "1px solid #A1A1A1",
                                        borderRadius: "6px",
                                        padding: ".2rem .5rem",
                                    }}
                                >
                                    {" "}
                                    {"Actions"} &nbsp;
                                    <Fa icon="angle-down" style={{ float: "right" }} />
                                </span>
                            </DropdownToggle>
                            <DropdownMenu basic style={{ width: "100%", zIndex: "9999" }}>
                                {this.state.actionItems?.map((action) => action)}
                            </DropdownMenu>
                        </Dropdown>
                    </MDBNavItem>
                </MDBNav>
            </div>
        );
    }

    render() {
        return this.renderNavTab();
    }
}
